import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentLoading from './AsyncComponentLoading';
import AsyncComponentError from './AsyncComponentError';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = props =>
/*#__PURE__*/
// @ts-expect-error ts-migrate(2786) FIXME: 'AsyncComponentLoading' cannot be used as a JSX co... Remove this comment to see the full error message
_jsx(AsyncComponentLoading, Object.assign({
  minHeight: 100
}, props));
LoadingComponent.displayName = 'AsyncMoreActionsDropdownOptions';
const AsyncMoreActionsDropdownOptions = Loadable({
  loader: () => import( /* webpackChunkName: "more-actions-dropdown" */'conversations-thread-view/chat-feed-actions-header/components/ConnectedMoreActionsDropdownOptions'),
  LoadingComponent,
  ErrorComponent: AsyncComponentError
});
export default AsyncMoreActionsDropdownOptions;